import axios from 'axios';

const isLocalDev = typeof window !== 'undefined' && window.location.port === '3000';
const defaultBaseURL = isLocalDev ? 'http://localhost:5001/api' : '/api';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || defaultBaseURL,
  timeout: 10000,
});

const setAuthHeader = (token: string | null) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
};

// Attach token on every request (axios 1.x may not apply defaults.headers.common reliably)
api.interceptors.request.use((config) => {
  if (typeof window === 'undefined') return config;
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = String(error?.config?.url || '');
    if (status === 401 && !url.includes('/auth/login')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setAuthHeader(null);
      window.dispatchEvent(new CustomEvent('auth:logout'));
    }
    return Promise.reject(error);
  }
);

if (typeof window !== 'undefined') {
  setAuthHeader(localStorage.getItem('token'));
}

export { setAuthHeader };
export default api;

